export default [
  { from: '/nao-autorizado', to: '/erro/nao-autorizado' },
  { from: '/erro-de-conexao', to: '/erro/erro-de-conexao' },
  { from: '/nao-encontrado', to: '/erro/nao-encontrado' },
  { from: '/navegador-nao-suportado', to: '/erro/navegador-nao-suportado' },
  { from: '/navegador-desatualizado', to: '/erro/navegador-desatualizado' },
  { from: '/erro-ao-carregar', to: '/erro/erro-ao-carregar' },
]
